import React from 'react';
import { Grid, TextField, Stack, Switch } from '@mui/material';
import { LIKERT_OPTION, QUESTION_TYPE } from '../../utils';
import { MULTI_OPTIONS } from '../../utils';
import { Close } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { MULTI_OPTION_TEMPLATE } from '../../utils';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import { AppButton } from '../../../../resources/styling';
import { colors } from '../../../../resources/theme/colors';
import Avatar from '@mui/material/Avatar';
import { Box } from '@mui/material';
import Modal from '@mui/material/Modal';
import artifactService from '../../../../services/api/insights/artifactService';
import { config } from '../../../../utils/config';
import EmojiPicker, { Emoji } from 'emoji-picker-react';
import { UploadButton } from '../../../../resources/styling/appStyle';
import { de } from 'date-fns/locale';

const { mandy, pictonBlue } = colors;

export default function MultiOption({
  questionData,
  setQuestionData,
  selectedTab,
}) {
  const [likertOption, setLikertOption] = React.useState(true);
  const [showImageUploader, setShowImageUploader] = React.useState(false);
  const [selectedOption, setSelectedOption] = React.useState(0);
  const [showEmojiUploader, setShowEmojiUploader] = React.useState(false);

  const getDivider = () => (
    <div style={{ marginLeft: 5, marginRight: 5 }}>
      <Divider orientation='vertical' flexIte />
    </div>
  );

  const getOptionTypeStyle = (val) => ({ display: !val ? 'inline' : 'none' });

  const setOptionType = (text, emoji, image) => {
    setQuestionData({
      ...questionData,
      isTextOption: text,
      isEmojiOption: emoji,
      isImageOption: image,
      multiOptionResponseAttributes: [
        ...questionData.multiOptionResponseAttributes,
      ],
      followupQuestions: [...questionData.followupQuestions],
      questionSettings: { ...questionData.questionSettings },
    });
  };

  const getOptionDisplayType = () => (
    <Stack direction='row' justifyContent='end' className='meta-text'>
      <Link
        href='#'
        underline='hover'
        onClick={(e) => setOptionType(true, false, false)}
        style={getOptionTypeStyle(questionData.isTextOption)}
      >
        Add Text
      </Link>
      {questionData.isImageOption ? getDivider() : null}{' '}
      <Link
        href='#'
        underline='hover'
        onClick={(e) => setOptionType(false, true, false)}
        style={getOptionTypeStyle(questionData.isEmojiOption)}
      >
        Add Emoji
      </Link>{' '}
      {!questionData.isImageOption ? getDivider() : null}
      <Link
        href='#'
        underline='hover'
        onClick={(e) => setOptionType(false, false, true)}
        style={getOptionTypeStyle(questionData.isImageOption)}
      >
        Add Image
      </Link>
    </Stack>
  );

  const renderImageUploader = () => (
    <Modal
      open={showImageUploader}
      onClose={() => setShowImageUploader(false)}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: 400,
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          p: 3,
        }}
      >
        <h3 style={{ marginBottom: '15px' }}>Upload Image</h3>
        <input
          type='file'
          accept='image/*'
          id='upload-image'
          onChange={(e) => {
            var formData = new FormData();
            formData.append('file', e.target.files[0]);
            artifactService
              .post(formData)
              .then((res) => {
                let newMultiOption =
                  questionData.multiOptionResponseAttributes.map(
                    (option, index) => {
                      if (index === selectedOption) {
                        selectedTab === 1
                          ? (option.staffImage = res.filePath)
                          : selectedTab === 2
                          ? (option.parentImage = res.filePath)
                          : (option.pupilImage = res.filePath);
                        option.numValue = index + 1;
                      }
                      return { ...option };
                    }
                  );
                setQuestionData({
                  ...questionData,
                  multiOptionResponseAttributes: [...newMultiOption],
                });
                setShowImageUploader(false);
              })
              .catch((err) => console.error(err))
              .finally(() => setShowImageUploader(false));
          }}
        />
      </Box>
    </Modal>
  );

  const renderEmojiUploader = () => (
    <Modal open={showEmojiUploader} onClose={() => setShowEmojiUploader(false)}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          //bgcolor: 'background.paper',
          //p: 1,
        }}
      >
        {/* <h3>Select Emoji</h3> */}
        <EmojiPicker
          skinTonesDisabled
          style={{ zIndex: 999 }}
          onEmojiClick={(e) => {
            let newMultiOption = questionData.multiOptionResponseAttributes.map(
              (option, index) => {
                if (index === selectedOption) {
                  selectedTab === 1
                    ? (option.staffEmoji = e.unified)
                    : selectedTab === 2
                    ? (option.parentEmoji = e.unified)
                    : (option.pupilEmoji = e.unified);
                  option.numValue = index + 1;
                }
                return { ...option };
              }
            );
            setQuestionData({
              ...questionData,
              multiOptionResponseAttributes: [...newMultiOption],
            });
            setShowEmojiUploader(false);
          }}
        />
      </Box>
    </Modal>
  );
  const DummyImage = (width, height) => (
    <Avatar
      variant='square'
      sx={{
        width: width,
        height: height,
        bgcolor: 'grey.100',
        border: '1px solid #E2E2E2',
      }}
    >
      <svg
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M1.92773 3.80002V18.2H20.255V3.80002H1.92773ZM3.23683 5.10911H18.9459V14.2112L15.4893 10.7343L15.0186 10.2637L12.0529 13.2294L8.28926 9.42518L7.81864 8.95456L3.23683 13.5364V5.10911ZM16.3277 6.4182C15.9805 6.4182 15.6476 6.55612 15.4021 6.80162C15.1566 7.04713 15.0186 7.3801 15.0186 7.72729C15.0186 8.07448 15.1566 8.40746 15.4021 8.65296C15.6476 8.89846 15.9805 9.03638 16.3277 9.03638C16.6749 9.03638 17.0079 8.89846 17.2534 8.65296C17.4989 8.40746 17.6368 8.07448 17.6368 7.72729C17.6368 7.3801 17.4989 7.04713 17.2534 6.80162C17.0079 6.55612 16.6749 6.4182 16.3277 6.4182ZM7.81864 10.8161L13.8326 16.8909H3.23683V15.3979L7.81864 10.8161ZM15.0186 12.1252L18.9459 16.0525V16.8909H15.6935L12.9732 14.1497L15.0186 12.1252Z'
          fill='#E2E2E2'
        />
      </svg>
    </Avatar>
  );

  return (
    (questionData.questionType === QUESTION_TYPE.LIKERT ||
      questionData.questionType === QUESTION_TYPE.YES_NO ||
      questionData.questionType === QUESTION_TYPE.YES_NO_MAYBE ||
      questionData.questionType === QUESTION_TYPE.MULTIPLE_SELECT ||
      questionData.questionType === QUESTION_TYPE.MULTIPLE_CHOICE) &&
    questionData.multiOptionResponseAttributes?.length > 0 && (
      <div className='answer-options'>
        {renderImageUploader()}
        {renderEmojiUploader()}
        <Grid container columnSpacing={1.5} rowSpacing={1.5}>
          <Grid item xs={6} lg={6} md={6} sm={6}>
            <div className='form-label'>Answer options</div>
          </Grid>
          <Grid item xs={6} lg={6} md={6} sm={6}>
            {getOptionDisplayType()}
          </Grid>
          <Grid item xs={12} lg={12} md={12} sm={12}>
            {questionData.questionType === QUESTION_TYPE.LIKERT && (
              <Grid container>
                <Grid item xs={12} lg={12} md={12} sm={12} mb={1}>
                  <Switch
                    size='small'
                    checked={likertOption}
                    onChange={(e) => setLikertOption(e.target.checked)}
                  />
                  Predefined likert answers{' '}
                </Grid>
                {likertOption &&
                  questionData.questionType === QUESTION_TYPE.LIKERT && (
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                      <Select
                        value={questionData.likertOption}
                        onChange={(e) => {
                          var selected = LIKERT_OPTION.filter(
                            (c) => c.value === e.target.value
                          )[0];
                          let options = selected?.label.split(', ');
                          let newMultiOption = [];
                          options.map((option, index) => {
                            newMultiOption.push({
                              ...MULTI_OPTION_TEMPLATE,
                              staffText: option,
                              parentText: option,
                              pupilText: option,
                              numValue: selected.polarity[index],
                              order: index + 1,
                              value: selected.polarity[index],
                            });
                          });
                          setQuestionData({
                            ...questionData,
                            likertOption: e.target.value,
                            multiOptionResponseAttributes: [...newMultiOption],
                          });
                        }}
                        fullWidth
                        size='small'
                      >
                        {LIKERT_OPTION.map((option, i) => (
                          <MenuItem value={option.value} key={i}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  )}
              </Grid>
            )}
          </Grid>
          {((questionData.questionType === QUESTION_TYPE.LIKERT &&
            !likertOption) ||
            questionData.questionType === QUESTION_TYPE.YES_NO ||
            questionData.questionType === QUESTION_TYPE.YES_NO_MAYBE ||
            questionData.questionType === QUESTION_TYPE.MULTIPLE_SELECT ||
            questionData.questionType === QUESTION_TYPE.MULTIPLE_CHOICE) &&
            questionData.multiOptionResponseAttributes.map((item, i) => (
              <Grid item xs={12} lg={6} md={6} sm={6}>
                {questionData.isTextOption && (
                  <Grid container spacing={0.3}>
                    <Grid
                      item
                      xs={9}
                      lg={10}
                      md={10}
                      sm={9}
                      sx={{ textAlign: 'center' }}
                    >
                      <TextField
                        size='small'
                        value={
                          selectedTab === 1
                            ? item.staffText
                            : selectedTab === 2
                            ? item.parentText
                            : item.pupilText
                        }
                        fullWidth
                        placeholder={'Answer ' + (i + 1)}
                        onChange={(e) => {
                          let newMultiOption =
                            questionData.multiOptionResponseAttributes.map(
                              (option, index) => {
                                if (index === i) {
                                  if (
                                    option.staffText === option.parentText &&
                                    option.staffText === option.pupilText
                                  ) {
                                    option.staffText = e.target.value;
                                    option.parentText = e.target.value;
                                    option.pupilText = e.target.value;
                                  }
                                  selectedTab === 1
                                    ? (option.staffText = e.target.value)
                                    : selectedTab === 2
                                    ? (option.parentText = e.target.value)
                                    : (option.pupilText = e.target.value);
                                  if (option.staffText === '') {
                                    option.staffText = e.target.value;
                                  }
                                  if (option.parentText === '') {
                                    option.parentText = e.target.value;
                                  }
                                  if (option.pupilText === '') {
                                    option.pupilText = e.target.value;
                                  }
                                }
                                return { ...option };
                              }
                            );
                          setQuestionData({
                            ...questionData,
                            multiOptionResponseAttributes: [...newMultiOption],
                          });
                        }}
                      />
                    </Grid>
                    <Grid item xs={3} lg={2} md={2} sm={3}>
                      <TextField
                        size='small'
                        value={item.numValue}
                        fullWidth
                        placeholder={'Num  ' + (i + 1)}
                        type='number'
                        onChange={(e) => {
                          let newMultiOption =
                            questionData.multiOptionResponseAttributes.map(
                              (option, index) => {
                                if (index === i) {
                                  return {
                                    ...option,
                                    numValue: parseInt(e.target.value),
                                  };
                                }
                                return option;
                              }
                            );

                          setQuestionData({
                            ...questionData,
                            multiOptionResponseAttributes: [...newMultiOption],
                          });
                        }}
                      />
                      {questionData.questionType !== QUESTION_TYPE.YES_NO &&
                        questionData.questionType !==
                          QUESTION_TYPE.YES_NO_MAYBE &&
                        questionData.multiOptionResponseAttributes.length >
                          2 && (
                          <IconButton
                            className='delete-option'
                            onClick={() => {
                              let newMultiOption =
                                questionData.multiOptionResponseAttributes.filter(
                                  (option, index) => index !== i
                                );
                              setQuestionData({
                                ...questionData,
                                multiOptionResponseAttributes: [
                                  ...newMultiOption,
                                ],
                              });
                            }}
                          >
                            <Close></Close>
                          </IconButton>
                        )}
                    </Grid>
                  </Grid>
                )}

                {questionData.isEmojiOption && (
                  <Grid container spacing={1}>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                      <Stack direction='row' spacing={1} alignItems='center'>
                        <div>
                          {item.staffEmoji ||
                          item.parentEmoji ||
                          item.pupilEmoji ? (
                            <Emoji
                              unified={
                                selectedTab === 1
                                  ? item.staffEmoji
                                  : selectedTab === 2
                                  ? item.parentEmoji
                                  : item.pupilEmoji
                              }
                              size={64}
                            />
                          ) : (
                            <DummyImage width={98} height={72} />
                          )}
                        </div>
                        <div>
                          <UploadButton
                            color={pictonBlue}
                            onClick={() => {
                              setSelectedOption(i);
                              setShowEmojiUploader(true);
                            }}
                          >
                            {item.staffEmoji ||
                            item.parentEmoji ||
                            item.pupilEmoji
                              ? 'Change'
                              : 'Upload'}{' '}
                            Emoji
                          </UploadButton>
                        </div>
                      </Stack>
                    </Grid>
                  </Grid>
                )}
                {questionData.isImageOption && (
                  <Grid container spacing={1}>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                      <Stack direction='row' spacing={1} alignItems='center'>
                        <div>
                          {item.staffImage ||
                          item.parentImage ||
                          item.pupilImage ? (
                            <img
                              src={`${
                                config.BASE_URL_Insights
                              }/Artifact/download?fileName=${
                                selectedTab === 1
                                  ? item.staffImage
                                  : selectedTab === 2
                                  ? item.parentImage
                                  : item.pupilImage
                              }`}
                              width={100}
                            />
                          ) : (
                            <DummyImage width={98} height={72} />
                          )}
                        </div>
                        <div>
                          <UploadButton
                            color={pictonBlue}
                            onClick={() => {
                              setShowImageUploader(true);
                              setSelectedOption(i);
                            }}
                          >
                            {item.staffImage ||
                            item.parentImage ||
                            item.pupilImage
                              ? 'Change'
                              : 'Upload'}{' '}
                            Image
                          </UploadButton>
                        </div>
                      </Stack>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            ))}
          {questionData.multiOptionResponseAttributes.length < 10 &&
            ((questionData.questionType === QUESTION_TYPE.LIKERT &&
              !likertOption) ||
              questionData.questionType === QUESTION_TYPE.MULTIPLE_SELECT ||
              questionData.questionType === QUESTION_TYPE.MULTIPLE_CHOICE) && (
              <Grid item xs={6} lg={6} md={6} sm={6}>
                <button
                  style={{
                    color: '#FF5939',
                    border: 0,
                    fontWeight: 'bold',
                  }}
                  onClick={() => {
                    let newMultiOption = {
                      ...MULTI_OPTIONS,
                      staffText: '',
                      parentText: '',
                      pupilText: '',
                      numValue:
                        questionData.multiOptionResponseAttributes.length + 1,
                      order:
                        questionData.multiOptionResponseAttributes.length + 1,
                      value:
                        questionData.multiOptionResponseAttributes.length + 1,
                    };
                    setQuestionData({
                      ...questionData,
                      multiOptionResponseAttributes: [
                        ...questionData.multiOptionResponseAttributes,
                        newMultiOption,
                      ],
                    });
                  }}
                >
                  {' '}
                  <Stack direction='row' spacing={1} alignItems='center'>
                    <AddIcon />
                    Add an answer option
                  </Stack>
                </button>
              </Grid>
            )}
        </Grid>
      </div>
    )
  );
}
